/* tslint:disable */
/* eslint-disable */
/**
 * KDS API
 * Internal KDS API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Sync200ResponseOneOf
 */
export interface Sync200ResponseOneOf {
    /**
     * 
     * @type {Array<any>}
     * @memberof Sync200ResponseOneOf
     */
    events: Array<any>;
}

/**
 * Check if a given object implements the Sync200ResponseOneOf interface.
 */
export function instanceOfSync200ResponseOneOf(value: object): value is Sync200ResponseOneOf {
    if (!('events' in value) || value['events'] === undefined) return false;
    return true;
}

export function Sync200ResponseOneOfFromJSON(json: any): Sync200ResponseOneOf {
    return Sync200ResponseOneOfFromJSONTyped(json, false);
}

export function Sync200ResponseOneOfFromJSONTyped(json: any, ignoreDiscriminator: boolean): Sync200ResponseOneOf {
    if (json == null) {
        return json;
    }
    return {
        
        'events': json['events'],
    };
}

export function Sync200ResponseOneOfToJSON(json: any): Sync200ResponseOneOf {
    return Sync200ResponseOneOfToJSONTyped(json, false);
}

export function Sync200ResponseOneOfToJSONTyped(value?: Sync200ResponseOneOf | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'events': value['events'],
    };
}

